let redirectSignIn = process.env.REACT_APP_REDIRECT_URI;
let redirectSignOut = process.env.REACT_APP_LOGOUT_REDIRECT_URI;
const redirectToOrigin = process.env.REACT_APP_REDIRECT_TO_ORIGIN;
const stage = process.env.REACT_APP_MR_STAGE;

const replaceOrigin = (url) => {
  const newUrl = new URL(url);
  if (typeof(window) !== 'undefined') {
    newUrl.host = window.location.host
  }
  return newUrl.href;
}

if (JSON.parse(redirectToOrigin)) {
  redirectSignIn = replaceOrigin(redirectSignIn);
  redirectSignOut = replaceOrigin(redirectSignOut);
}

if (stage != 'prod') {
  console.log("REACT_APP_REDIRECT_TO_ORIGIN: ", redirectToOrigin);
  console.log("redirectSignIn: ", redirectSignIn, ' ---- ', typeof(redirectSignIn));
  console.log("redirectSignOut: ", redirectSignOut, ' ---- ', typeof(redirectSignOut));
}

export default {
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_USER_POOL_ID,
      userPoolClientId: process.env.REACT_APP_CLIENT_ID,
      loginWith: {
        oauth: {
          domain: process.env.REACT_APP_DOMAIN,
          scopes: [
            'phone', 
            'email', 
            'profile', 
            'openid', 
            'aws.cognito.signin.user.admin'
          ],
          redirectSignIn: [redirectSignIn],
          redirectSignOut: [redirectSignOut],
          responseType: 'code'
        }
      }
    }
  }
}